import { useState } from "react";
import StudentHeader from "../components/StudentHeader";
import { reflectionPrompts, moods } from "../data/studentData";
import { methods } from "../data/methodsData";

const KEY = "mushtariy_reflection";
const inputStyle = { padding: "12px", border: "1px solid #ddd", borderRadius: "8px", width: "100%" };

const loadEntries = () => {
    try {
        return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
        return [];
    }
};

const persist = (entries) => {
    try {
        localStorage.setItem(KEY, JSON.stringify(entries));
    } catch {
        // e'tiborsiz
    }
};

const emptyForm = () => ({ date: new Date().toISOString().slice(0, 10), topic: "", method: "", mood: 0, answers: {} });

const escapeHtml = (s) => String(s).replace(/[&<>"]/g, (ch) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[ch]));

function Reflection() {
    const [entries, setEntries] = useState(loadEntries);
    const [form, setForm] = useState(emptyForm);
    const [open, setOpen] = useState(null);

    const filled = reflectionPrompts.filter((p) => (form.answers[p.id] || "").trim()).length;
    const canSave = form.topic.trim() && form.mood && filled >= 3;

    const save = () => {
        const next = [{ ...form, id: Date.now() }, ...entries];
        setEntries(next);
        persist(next);
        setForm(emptyForm());
    };

    const remove = (id) => {
        if (!window.confirm("Yozuv o'chirilsinmi?")) return;
        const next = entries.filter((e) => e.id !== id);
        setEntries(next);
        persist(next);
    };

    // Brauzerning chop etish oynasi orqali — har qanday yozuv (lotin/kirill) to'g'ri chiqadi
    const printPortfolio = () => {
        const w = window.open("", "_blank");
        if (!w) return;
        const body = entries.map((e) => `
            <div class="entry">
                <h3>${escapeHtml(e.date)} — ${escapeHtml(e.topic)}</h3>
                <p class="meta">Metod: ${escapeHtml(e.method || "—")} · Kayfiyat: ${escapeHtml(moods.find((m) => m.id === e.mood)?.label || "")}</p>
                ${reflectionPrompts.map((p) => e.answers[p.id] ? `<p><b>${escapeHtml(p.label)}</b><br>${escapeHtml(e.answers[p.id])}</p>` : "").join("")}
            </div>`).join("");
        w.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>Refleksiv kundalik</title>
            <style>body{font-family:Arial,sans-serif;max-width:760px;margin:30px auto;color:#222;line-height:1.5}
            h1{text-align:center}.entry{border-bottom:1px solid #ccc;padding:10px 0;page-break-inside:avoid}.meta{color:#666;font-size:13px}</style>
            </head><body><h1>Refleksiv kundalik (portfolio)</h1>${body}</body></html>`);
        w.document.close();
        w.focus();
        w.print();
    };

    const methodCounts = methods
        .map((m) => ({ name: m.name, count: entries.filter((e) => e.method === m.name).length }))
        .filter((m) => m.count > 0);

    return (
        <>
            <StudentHeader title="Refleksiv kundalik" crumb="Kundalik" />
            <section className="pricing-one section-space-bottom">
                <div className="container">
                    <div className="pricing-one__main-tab-box tabs-box">
                        <div className="pricing-one__top">
                            <div className="pricing-one__content">
                                <h3 className="pricing-one__title">Pedagogik amaliyot kundaligi</h3>
                                <p className="pricing-one__text">
                                    Har bir o'tkazgan yoki kuzatgan mashg'ulotingizdan so'ng yo'naltiruvchi savollarga javob yozing.
                                    Muntazam refleksiya — kasbiy o'sishning eng samarali yo'li. Yozuvlar shu qurilmada saqlanadi.
                                </p>
                            </div>
                        </div>
                        <div className="pricing-one__inner px-3 px-lg-5" style={{ paddingBottom: 40 }}>
                            <div className="row gutter-y-20">
                                <div className="col-md-4">
                                    <label className="d-block mb-2"><strong>Sana</strong></label>
                                    <input type="date" style={inputStyle} value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} />
                                </div>
                                <div className="col-md-4">
                                    <label className="d-block mb-2"><strong>Mashg'ulot mavzusi</strong></label>
                                    <input type="text" placeholder="masalan: Kuz fasli" style={inputStyle} value={form.topic} onChange={(e) => setForm({ ...form, topic: e.target.value })} />
                                </div>
                                <div className="col-md-4">
                                    <label className="d-block mb-2"><strong>Qo'llangan metod</strong></label>
                                    <select style={inputStyle} value={form.method} onChange={(e) => setForm({ ...form, method: e.target.value })}>
                                        <option value="">— tanlang —</option>
                                        {methods.map((m) => <option key={m.id} value={m.name}>{m.name}</option>)}
                                        <option value="Boshqa">Boshqa</option>
                                    </select>
                                </div>
                            </div>

                            <label className="d-block mt-4 mb-2"><strong>Mashg'ulot qanday o'tdi?</strong></label>
                            <div className="d-flex" style={{ gap: 10, flexWrap: "wrap" }}>
                                {moods.map((m) => (
                                    <button key={m.id} onClick={() => setForm({ ...form, mood: m.id })} style={{
                                        padding: "10px 16px", borderRadius: 10, cursor: "pointer",
                                        border: form.mood === m.id ? "2px solid #ffb606" : "1px solid #ddd",
                                        background: form.mood === m.id ? "#fff8e6" : "#fff"
                                    }}>
                                        <span style={{ fontSize: 22, marginRight: 6 }}>{m.emoji}</span>{m.label}
                                    </button>
                                ))}
                            </div>

                            {reflectionPrompts.map((p, i) => (
                                <div key={p.id} className="mt-4">
                                    <label className="d-block mb-2"><strong>{i + 1}. {p.label}</strong></label>
                                    <textarea
                                        rows={3}
                                        placeholder={p.placeholder}
                                        style={{ ...inputStyle, resize: "vertical" }}
                                        value={form.answers[p.id] || ""}
                                        onChange={(e) => setForm({ ...form, answers: { ...form.answers, [p.id]: e.target.value } })}
                                    />
                                </div>
                            ))}

                            <div className="mt-4">
                                <button onClick={save} disabled={!canSave} className="eduhive-btn" style={{ border: "none", opacity: canSave ? 1 : 0.5 }}>
                                    <span>Yozuvni saqlash</span>
                                    <span className="eduhive-btn__icon">
                                        <span className="eduhive-btn__icon__inner"><i className="icon-right-arrow"></i></span>
                                    </span>
                                </button>
                                {!canSave && <p style={{ fontSize: 14, color: "#999", marginTop: 8 }}>Mavzu, kayfiyat va kamida 3 ta savolga javob kerak.</p>}
                            </div>

                            {entries.length > 0 && (
                                <div style={{ marginTop: 50 }}>
                                    <div className="d-flex justify-content-between align-items-center mb-3" style={{ gap: 10, flexWrap: "wrap" }}>
                                        <h4 style={{ margin: 0 }}>Mening portfoliom ({entries.length} ta yozuv)</h4>
                                        <button onClick={printPortfolio} className="eduhive-btn" style={{ border: "none" }}>
                                            <span>Chop etish / PDF</span>
                                        </button>
                                    </div>
                                    {methodCounts.length > 0 && (
                                        <p style={{ color: "#666" }}>
                                            Sinab ko'rilgan metodlar: {methodCounts.map((m) => `${m.name} (${m.count})`).join(", ")}
                                        </p>
                                    )}
                                    {entries.map((e) => (
                                        <div key={e.id} style={{ background: "#fafafa", borderRadius: 12, padding: 16, marginBottom: 12 }}>
                                            <div className="d-flex justify-content-between align-items-center" style={{ gap: 10, cursor: "pointer" }} onClick={() => setOpen(open === e.id ? null : e.id)}>
                                                <span>
                                                    <span style={{ fontSize: 20, marginRight: 8 }}>{moods.find((m) => m.id === e.mood)?.emoji}</span>
                                                    <strong>{e.topic}</strong>
                                                    <span style={{ color: "#999", marginLeft: 8, fontSize: 14 }}>{e.date}{e.method ? ` · ${e.method}` : ""}</span>
                                                </span>
                                                <button
                                                    onClick={(ev) => { ev.stopPropagation(); remove(e.id); }}
                                                    style={{ border: "none", background: "none", color: "#ef4444", cursor: "pointer" }}
                                                    title="O'chirish"
                                                >
                                                    <i className="icon-cross"></i>
                                                </button>
                                            </div>
                                            {open === e.id && (
                                                <div className="mt-3">
                                                    {reflectionPrompts.filter((p) => e.answers[p.id]).map((p) => (
                                                        <p key={p.id} style={{ marginBottom: 10 }}>
                                                            <strong style={{ fontSize: 14 }}>{p.label}</strong><br />
                                                            <span style={{ whiteSpace: "pre-wrap" }}>{e.answers[p.id]}</span>
                                                        </p>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Reflection;
